module.exports = __webpack_public_path__ + "static/media/email_active.87de6e8b.svg";